module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/009-uganda-fcf6abf03e771a1c0598168f51f78ce3.svg";